import {fetchAuthSession} from 'aws-amplify/auth';
import type {AxiosResponse} from 'axios';
import axios from 'axios';
import fileDownload from 'js-file-download';
import {ApiEndpoints as Endpoints} from 'src/shared/constants/apiEndpoints';
/**
 * @registry Re-export of the generated API endpoint path constants.
 */
export const ApiEndpoints = Endpoints;

const isLocalhost = import.meta.env.VITE_ENV === 'local';

const uploadConfig = !isLocalhost
  ? {} // {'x-amz-server-side-encryption': 'aws:kms'}
  : {};

/**
 * @registry Downloads a file from the API and saves it client-side via js-file-download.
 */
export const ApiCallerDownloadFile = async (
  url: string,
  filename: string
): Promise<any> =>
  axios
    .get(`${import.meta.env.VITE_API}${url}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${
          (await fetchAuthSession())?.tokens?.accessToken
        }`,
        email: localStorage.getItem('email'),
      },
    })
    .then(response => {
      fileDownload(response.data, filename);
      return response.data;
    });

interface ApiCallerProps {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  endpointURL: string;
  data?: any;
  contentType?: string;
  customEndpointURL?: string;
}
/**
 * @registry Default axios request wrapper — attaches Cognito auth header and calls the API.
 */
export default async function ApiCaller({
  method,
  endpointURL,
  data,
  contentType,
  customEndpointURL,
}: ApiCallerProps): Promise<AxiosResponse<any>> {
  const customHeader = !customEndpointURL
    ? {
        Authorization: `Bearer ${
          (await fetchAuthSession())?.tokens?.accessToken
        }`,
        ssoAudience: window.localStorage.getItem('sso_audience'),
        ssoIssuer: window.localStorage.getItem('sso_issuer'),
        email: window.localStorage.getItem('email'),
      }
    : {...uploadConfig, ...{'Content-Type': contentType}};

  const config: any = {
    baseURL: !customEndpointURL ? import.meta.env.VITE_API : customEndpointURL,
    method,
    url: !customEndpointURL && endpointURL,
    data,
    headers: customHeader,
  };

  return axios.request(config);
}
